import {
    FaReact, FaAngular, FaVuejs, FaNodeJs, FaPython, FaDocker, FaAws, FaGitAlt, FaDatabase, FaCloud, FaCode, FaChartBar
} from 'react-icons/fa';
import {
    SiTailwindcss, SiVite, SiGatsby, SiExpress, SiNestjs, SiDjango, SiFlask, SiDotnet, SiGraphql, SiSwagger, SiSpringboot, SiMongodb, SiFirebase, SiPostgresql, SiSqlite, SiMysql, SiKubernetes, SiGooglecloud, SiSplunk, SiTableau, SiFlutter 
} from 'react-icons/si';
import { DiJava} from "react-icons/di";

export const techIcons = {
    'React': <FaReact />,
    'Angular': <FaAngular />,
    'Vue.js': <FaVuejs />,
    'Tailwind CSS': <SiTailwindcss />,
    'Vite': <SiVite />,
    'Gatsby': <SiGatsby />,
    'Node.js': <FaNodeJs />,
    'Express.js': <SiExpress />,
    'Nest.js': <SiNestjs />,
    'Python': <FaPython />,
    'Django': <SiDjango />,
    'Flask': <SiFlask />,
    '.NET / ASP.NET Core': <SiDotnet />,
    'GraphQL': <SiGraphql />,
    'Swagger': <SiSwagger />,
    'Java EE': <DiJava />,
    'Spring Boot': <SiSpringboot />,
    'MongoDB': <SiMongodb />,
    'Firebase': <SiFirebase />,
    'PostgreSQL': <SiPostgresql />,
    'SQL Server': <FaDatabase />,
    'SQLite': <SiSqlite />,
    'MySQL': <SiMysql />,
    'Docker': <FaDocker />,
    'Kubernetes': <SiKubernetes />,
    'GitHub / GitLab / Git SCM': <FaGitAlt />,
    'Amazon Web Services (AWS)': <FaAws />,
    'Google Cloud': <SiGooglecloud />,
    'Azure': <FaCloud />,
    'Splunk': <SiSplunk />,
    'Visual Studio / VS Code': <FaCode />,
    'Google Gemini': null,
    'Power BI (with Copilot)': <FaChartBar />,
    'Tableau': <SiTableau />,
    'Jasper AI': null,
    'React Native': <FaReact />,
    'Flutter': <SiFlutter />,
    'Swift / Kotlin': null,
};
